import type { IAxiosInstance } from "../../AbstractApiClient/AbstractApiClient";
import { resolveTaxableLocation } from "./resolveTaxableLocation/resolveTaxableLocation";

export function TaxableLocationApi(instance: IAxiosInstance) {
  return {
    Resolve: resolveTaxableLocation(instance),
  };
}
